import React from "react";
import { useNavigate } from "react-router";
import ThemeToggle from "./commonComponents/ThemeToggle";
import styled from "styled-components";
import { useSelector } from "react-redux";

const LandingPageNavbar = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.auth.userData);

  return (
    <Box>
      <div className="navbarLeft">
        <h1 onClick={() => navigate("/")}>
          Brain Quiz <span>•</span>
        </h1>
      </div>

      <div className="navbarRight">
        <span className="themeBox"><ThemeToggle /></span>
        {userData && <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>}
      </div>
    </Box>
  );
};

export default LandingPageNavbar;


const Box = styled.div`
  max-width: 100%;
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: var(--background-color);
  opacity: 0.95;
  box-shadow: 0 0 3px var(--color);
  z-index: 1000;

.navbarLeft {
  margin-left: 3vw;

  h1 {
    font-size: 4rem;
    cursor: pointer;
  }

  h1 span {
    color: var(--orange);
    font-size: 4rem;
    margin-left: -3px;
  }
}


.navbarRight {
  margin-right: 2vw;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 3rem;

  .themeBox {
    height: 50%;
    display: flex;
    align-items: center;
    margin-top: 2rem;
  }

  button {
    display: flex;
    align-self: center;
    font-size: 1.75rem;
    font-weight: 600;
    padding: 1rem 1.5rem;
    background-color: var(--orange);
    color: var(--white);
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
  }
}

@media (max-width: 420px) {
  .navbarLeft h1 {
    font-size: 5rem;
  }

  .navbarLeft h1 span {
    font-size: 5rem;
  }
}


`